// client/src/components/LocaleResolver.tsx — OTT 2026
//
// Verifica UNA VOLTA all'avvio se l'account è un locale/tappa.
//
// Perché esiste: dopo l'aggiornamento l'app restava bloccata sulla rotellina.
// L'utente salvato in localStorage non ha il campo `is_locale`, e il refresh
// in background non lo restituiva: le aree protette aspettavano un dato che
// non arrivava mai. Ora:
//   - chiediamo /api/auth/me una volta e uniamo il risultato al profilo;
//   - dopo 4 secondi, qualunque cosa succeda, smettiamo di aspettare
//     (`localePending` torna false): l'app si apre sempre.
import React, { useEffect } from "react";

import { apiFetch } from "@/api/core/apiFetch";
import useAuthStore from "@/store/useAuthStore";

const RESOLVE_TIMEOUT_MS = 4000;

const LocaleResolver: React.FC = () => {
  const userId = useAuthStore((s) => s.user?.id);
  const userType = useAuthStore((s) => s.user?.user_type);
  const isLocale = useAuthStore((s) => s.user?.is_locale);

  useEffect(() => {
    if (!userId || userType !== "dealer" || isLocale !== undefined) return;

    let cancelled = false;
    const { applyUserPatch } = useAuthStore.getState();
    useAuthStore.setState({ localePending: true });

    const timer = window.setTimeout(() => {
      if (!cancelled) useAuthStore.setState({ localePending: false });
    }, RESOLVE_TIMEOUT_MS);

    apiFetch<{ user?: { is_locale?: boolean } }>("/api/auth/me")
      .then((res) => {
        if (cancelled || !res?.user) return;
        if (typeof res.user.is_locale === "boolean") {
          applyUserPatch({ is_locale: res.user.is_locale });
        }
      })
      .catch(() => {
        /* rete assente o sessione scaduta: l'app resta utilizzabile */
      })
      .finally(() => {
        window.clearTimeout(timer);
        if (!cancelled) useAuthStore.setState({ localePending: false });
      });

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [userId, userType, isLocale]);

  return null;
};

export default LocaleResolver;
